import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_SURVEYS } from '@/api/endpoints';
import { SURVEYS_QUERY_KEY } from '@/api/queryKeys';
import { toSurveys } from '@/pages/Mail/surveys';
import type { Survey, SurveyResponse } from '@/types/survey';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useSurveys = (isEnabled: boolean) =>
  useQuery<SurveyResponse[], Error, Survey[]>({
    queryKey: SURVEYS_QUERY_KEY,
    queryFn: () =>
      apiClient.get<SurveyResponse[]>(API_SURVEYS).then(unwrapAxiosResponse),
    select: toSurveys,
    enabled: isEnabled,
  });
